"use client";

import { useEffect, useState } from "react";
import { getWorldCupCountdownParts, type WorldCupCountdownParts } from "@/lib/world-cup-constants";

export function WorldCupCountdown({ initialParts }: { initialParts: WorldCupCountdownParts }) {
  const [parts, setParts] = useState(initialParts);

  useEffect(() => {
    const id = window.setInterval(() => setParts(getWorldCupCountdownParts()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <section className="w-full max-w-full rounded-lg bg-[#101010] px-4 py-4 text-white shadow-sm">
      <h2 className="mb-3 text-xs font-black uppercase tracking-[0.22em] text-[#E5A331]">Visszaszámláló</h2>
      <div className="flex min-w-0 items-center justify-between">
        {[
          ["NAP", parts.days, "text-white"],
          ["ÓRA", parts.hours, "text-[#E5A331]"],
          ["PERC", parts.minutes, "text-[#E5A331]"],
          ["MP", parts.seconds, "text-[#E5A331]"],
        ].map(([label, value, color], index) => (
          <div key={label} className="flex min-w-0 flex-1 items-center">
            {index > 0 ? <div className="h-9 w-px bg-[#E5A331]/25" aria-hidden="true" /> : null}
            <div className="min-w-0 flex-1 px-2 text-center">
              <p className={`text-2xl font-black leading-none tabular-nums sm:text-3xl ${color}`}>{value}</p>
              <p className="mt-1 text-[9px] font-black uppercase tracking-[0.16em] text-white/65">{label}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
